import { useInfiniteQuery } from 'react-query';
import { useAPI } from './useAPI';
import { useChuckClientContext } from './useChuckClientContext';
import { CacheKeys } from '../constants';
const LIMIT = 50;
export const useMessages = (thread, visibility) => {
    const { get } = useAPI();
    const { client } = useChuckClientContext();
    return useInfiniteQuery([CacheKeys.MESSAGES, thread, visibility], ({ pageParam = 0 }) => get({
        url: `/messages`,
        misc: {
            params: {
                thread,
                visibility,
                skip: pageParam,
                limit: LIMIT
            }
        }
    }).then((res) => {
        return res.data;
    }), {
        getNextPageParam: (lastPage, pages) => {
            if (!lastPage.meta.hasMore)
                return;
            return pages.reduce((acc, v) => acc + v.records.length, 0);
        },
        onError: (err) => {
            client.captureException(err);
        }
    });
};
//# sourceMappingURL=useMessages.js.map